export default __webpack_public_path__ + "i18n/translations/translation-te.e8fb4fca.json";